<template>
  <v-app>
    <v-system-bar
        :color="environment.colors"
        v-html="environment.html"
    ></v-system-bar>
    <router-view/>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
    environments: {
      dev: {
        colors: 'green white--text',
        text: 'deweloperskie',
      },
      prod: {
        colors: 'red darken-4 white--text',
        text: 'produkcyjne',
      },
    },
    environment: {
      colors: null,
      html: null,
    },
  }),
  created() {
    const environmentName = this.getEnvironmentName();
    const environmentSettings = this.environments[environmentName];

    this.environment.colors = environmentSettings.colors;
    this.environment.html = `Łączysz się do: ${process.env.VUE_APP_API_URL} (API ${environmentSettings.text}).`;
  },
  methods: {
    getEnvironmentName() {
      if (String(process.env.VUE_APP_API_URL).includes('api.centrum-rezerwacji.pl')) {
        return 'prod';
      }

      return 'dev';
    },
  }
};
</script>
